export enum TemplateType {
    HOME = 'Homepage Template',
    EDITORIAL = 'Editorial Page Template',
    EDITORIAL_OVERVIEW = 'Editorial Overview Page Template',
    FEATURE_APP = 'Feature App Template',
    MODEL_OVERVIEW = 'Model Overview Page Template',
    SHOWROOM = 'Showroom Page Template'
}
